<template>
  <a-form-item :label="label" :required="required" :extra="extra">
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      mode="multiple"
      show-arrow
      v-model:value="values"
      @change="handleChange"
      placeholder="Seleccione..."
    >
      <a-select-option v-for="value in item" :key="value.id">
        {{ value.name }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
import { defineComponent, ref } from "vue";
export default defineComponent({
  props: {
    item: {
      required: true,
      type: Array,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
    required: { type: Boolean, default: false },
    extra: { type: String, default: ""},
  },
  setup() {
    const values = ref([]);
    return {
      values,
    };
  },
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    },
    handleBlur() {
      this.$emit("blur");
    },
  },
});
</script>

<style lang="sass" scoped>
.text
  padding: 12px 24px
  margin: 0

  &--bold
    color: $gray-9
    font-weight: 600
</style>
